export function MenuItem ({title, onClick}) {
  return (
    <div className="cursor-pointer group" onClick={() => onClick()}>
      <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out">{"> "}</span>
      <span>{title}</span>
    </div>
  )
}
